import React, { useState } from "react";
import settingable from "fantastic/components/hoc/settingable";
import SocialForm from "fantastic/components/common/controls/social/SocialForm";
import IconSizeSettings from "fantastic/components/common/controls/IconSizeSettings";
import HorizontalPositionSettings from "fantastic/components/common/controls/background/HorizontalPositionSettings";

const SocialSettings = ({ selected, update, selectedNode }) => {
  const onChange = (field, value) => {
    update(selected, { [field]: value });
  };

  const positionSetting = {
    onChange,
    position: {
      field: "text_align",
      value: selectedNode.text_align
    }
  };

  const iconSettings = {
    onChange,
    size: {
      field: "size",
      value: selectedNode.size
    }
  };

  const socialsSettings = {
    onChange,
    socials: selectedNode.socials
  }

  return (
    <div>
      <div className="form-group">
        <IconSizeSettings {...iconSettings} />
        <div className="pull-right">
          <HorizontalPositionSettings {...positionSetting} />
        </div>
      </div>
      <div className="form-group">
        <SocialForm {...socialsSettings} />
      </div>
    </div>
  );
};

export default settingable("padding", "visibility")(SocialSettings);
